"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResistOfInjection = void 0;
var _react = require("react");
var _helpers = require("./helpers");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var MUTATION_OBSERVER_CONFIG = {
  attributes: true,
  childList: true,
  subtree: true
};
var useResistOfInjection = exports.useResistOfInjection = function useResistOfInjection() {
  var nodeDOMRef = (0, _react.useRef)(null);
  var promiseRef = (0, _react.useRef)(null);
  var setRef = (0, _react.useMemo)(function () {
    var resolve;
    var promise = new Promise(function (res) {
      resolve = res;
    });
    promiseRef.current = promise;
    return function (nodeDOM) {
      nodeDOMRef.current = nodeDOM;
      resolve(nodeDOM);
    };
  }, []);
  var getRefPromise = (0, _react.useCallback)(function () {
    if (nodeDOMRef.current) {
      return Promise.resolve(nodeDOMRef.current);
    }
    return promiseRef;
  }, []);
  (0, _react.useEffect)(function () {
    var promise = promiseRef.current;
    var observer = null;
    promise.then(function (nodeDOM) {
      if (nodeDOM) {
        observer = new MutationObserver(function (mutationList) {
          var _iterator = _createForOfIteratorHelper(mutationList),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var mutation = _step.value;
              if (mutation.type === 'childList') {
                var addedNodes = mutation.addedNodes;
                var _addedNodes = _slicedToArray(addedNodes, 1),
                  injectionNode = _addedNodes[0];
                if (injectionNode && (0, _helpers.shouldValidateNode)(injectionNode)) {
                  if (!_helpers.isReactNodeDOM) {
                    var _injectionNode$parent;
                    if (__DEV__) {
                      console.warn(injectionNode, 'This node was removed, because it is an external injection!!!');
                    }
                    (_injectionNode$parent = injectionNode.parentNode) === null || _injectionNode$parent === void 0 ? void 0 : _injectionNode$parent.removeChild(injectionNode);
                  }
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });
        observer.observe(nodeDOM, MUTATION_OBSERVER_CONFIG);
      }
    });
    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);
  return {
    nodeDOMRef: nodeDOMRef,
    getRefPromise: getRefPromise,
    setRef: setRef
  };
};